import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { string } from 'prop-types';
import { createMarkup } from '../../utils/utils';

const propTypes = {
  agency: string.isRequired,
};

const FlowAgencyBanner = ({ agency }) => (
  <div className="flow-notice">
    <div className="flow-notice-container">
      <p className="flow-notice-title">
        <strong>
          <FormattedMessage
            id={`flow.form.agency.${agency}.title`}
            defaultMessage={`This flow is created to work with ${agency}`}
          />
        </strong>
      </p>

      <FormattedMessage
        id={`flow.form.agency.${agency}.desc`}
        defaultMessage="This flow has a number of limitations:
          <ul><li>A/B Test is disabled</li>
          <li>Trafficback is disabled</li>
          <li>You can't change the flow settings</li></ul>"
      >
        {description => (
          <div
            className="flow-notice-description"
            dangerouslySetInnerHTML={createMarkup(description)}
          />
        )}
      </FormattedMessage>

      <p className="no-margin">
        <FormattedMessage
          id="flow.form.agency.desclaimer.part-1"
          defaultMessage="If necessary you can"
        />{' '}
        <Link to="/tools/flows/create">
          <FormattedMessage
            id="flow.form.agency.desclaimer.part-2"
            defaultMessage="create a new flow"
          />
        </Link>
      </p>
    </div>
  </div>
);

FlowAgencyBanner.propTypes = propTypes;

export default FlowAgencyBanner;
